<template>
    <el-select v-model="selectedValue" placeholder="请选择" style="width: 100%;" :disabled="disabled">
      <el-option v-for="(item,index) in list" :key="index"  :label="item.label" :value="item.value"></el-option>
    </el-select>
</template>
<script>
export default {
  name: 'XrSelect',
  props: ['list', 'value', 'readonly', 'disabled'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      selectedValue: ''
    }
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
    list: {
      handler() {
        this.selectedValue = this.value;
      },
      deep: true
    },
    selectedValue(newValue){
      this.$emit('change', newValue);
    }
  },
  created() {
    this.$nextTick(()=>{
      this.selectedValue = this.value;
    })
  },
  methods: {
    selectedChange(){
    }
  }
}
</script>

<style lang="scss" scoped>
  /** 按钮样式 */
  .th-button{
    display: inline;
    border: 1px solid #d9d9d9;
    padding: 4px 10px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    color: rgba(0,0,0,.65);
    margin-right: 8px;
  }

  .primary{
    background: #007aff;
    color: #fff;
  }



</style>



// WEBPACK FOOTER //
// src/components/XrSelect/index.vue